import * as S from "./plansModal.style";
import { SVG } from "~/spocketUI/components/SVG";
import { faClose } from "@fortawesome/pro-light-svg-icons";
import { useEffect, useState } from "react";
import { Plans } from "~/components/plans";
import { SHOW_PLANS_MODAL, triggerShowResumeModal } from "~/spocketUI/helpers/customEvents";
import ReactDOM from "react-dom";
import { usePlanFeature } from "~/hooks/usePlanFeature";

export const PlansModal = () => {
  const [showPlansModal, setShowPlansModal] = useState(false);
  const { isFeaturePaused } = usePlanFeature();

  // Show plans modal when user needs to upgrade
  useEffect(() => {
    const handleRequiresUpgrade = () => {
      if (isFeaturePaused()) {
        triggerShowResumeModal();
      } else {
        setShowPlansModal(true);
      }
    }
    // @ts-ignore
    window.addEventListener(SHOW_PLANS_MODAL, handleRequiresUpgrade);
    return () => {
      // @ts-ignore
      window.removeEventListener(SHOW_PLANS_MODAL, handleRequiresUpgrade);
    };
  }, [isFeaturePaused]);

  if (!showPlansModal) return null;

  return ReactDOM.createPortal(
    <S.ModalWrapper>
      <S.ModalContent>
        <S.CloseContainer onClick={() => setShowPlansModal(false)}>
          <SVG icon={faClose} size="xl" />
        </S.CloseContainer>
        <Plans closeModal={() => setShowPlansModal(false)} />
      </S.ModalContent>
    </S.ModalWrapper>,
    document.body
  );
};
